import { ComponentWithFilters } from '__generated__/graphql';
import { SlotsGroqQuery } from 'groq/ContentSlots';
import {
  CallToActionObject,
  CallToActionObjectType,
} from 'groq/objects/CallToActionObject';
import {
  SanityImageObject,
  SanityImageObjectType,
} from 'groq/objects/SanityImageObject';
import { LocaleSeo, LocaleSeoType } from 'groq/shared/LocaleSeo';
import { LocaleString, LocaleStringType } from 'groq/shared/LocaleString';
import { Maybe } from 'utils/types';
import { ProductObjectType } from 'groq/global-types';

type LaunchCalendarProductType = ProductObjectType & {
  productImage?: Maybe<SanityImageObjectType>;
  launchDate: string;
  launchCalendarProductName: string;
  launchCopy?: Maybe<LocaleStringType>;
  ctaCopy?: Maybe<LocaleStringType>;
  cta?: Maybe<Array<CallToActionObjectType>>;
  availableFrom?: Maybe<string>;
  availableTo?: Maybe<string>;
  appExclusive?: Maybe<boolean>;
  disableProductLink?: Maybe<boolean>;
  imageView?: Maybe<string>;
  released?: Maybe<boolean>;
};

export type LaunchCalendarPageType = {
  _id: string;
  _type: string;
  seo?: Maybe<LocaleSeoType>; //TODO seo object type
  aboveContent?: Maybe<ComponentWithFilters>;
  belowContent?: Maybe<ComponentWithFilters>;
  products?: Maybe<Array<LaunchCalendarProductType>>;
};

export const LaunchCalendarPageQuery = `
*[_type == "DropCalendarPage" && country == upper($country)][0] {
  _id,
  _type,
  ${LocaleSeo('seo')},
  aboveContent[] ${SlotsGroqQuery()},
  belowContent[] ${SlotsGroqQuery()},
  "products": products[] | order(launchDate asc) {
    "_type": "Message",
    ${SanityImageObject('productImage')},
    color,
    launchDate,
    masterId,
    productId,
    productName,
    launchCalendarProductName,
    ${LocaleString('launchCopy')},
    ${LocaleString('ctaCopy')},
    ${CallToActionObject('cta[]')},
    availableFrom,
    availableTo,
    header,
    subHeader,
    appExclusive,
    disableProductLink,
    imageView,
    "released": select(
      dateTime(launchDate) <= dateTime(now())
    )
  }
}
`;
